import React, { useEffect, useState } from "react";
import { Modal, Form } from "react-bootstrap";
import { useMutation, useQuery } from "react-query";
import {
  getRoles,
  postVendors,
  showVendors,
  updateVendors,
} from "../../MyApi/vendors";   

import { Spinner } from "reactstrap";
import { toast } from "react-toastify";
import EnhancedSearchStore from "../UI/enhancedstoresearch";
import LangSelectModal from "../UI/langselectmodal";
import i18next from "i18next";
import SkeletonWrapper from "../UI/skeletonWrapper";
import PhoneField from "../UI/phoneInput";
import { isValidPhoneNumber, isPossiblePhoneNumber } from "react-phone-number-input";
import EnhancedSearchStoreGroup from "../UI/enhancedStoreGroupSearch";
const AddEmployeeModal = ({
  show,
  onClose,
  refetch,
  modalMode,
  id,
  store_id,
  store_name,
  onVendorCreated, 
            is_store =true ,
            

}) => {
  const [formData, setFormData] = useState({
    first_name: "",
    last_name: "",
    role: "",
    email: "",
    phone: "",
    phone_code: "",
    store_name:"",
    store_id: "",
    is_active: 1,
    is_owner: 1,
  });

  useEffect(() => {
    if (store_id && store_name) {
      setFormData((prev) => ({ ...prev,  store_id  ,store_name}));
    }
  }, [store_name ,store_id]);

  const lang = i18next.language;
  const [selectedLangCode, setSelectedLangCode] = useState(lang);
  const [errors, setErrors] = useState({});


  const { data: showEmploy, isLoading } = useQuery(
    ["showVendors", id, selectedLangCode],
    () => showVendors(id, selectedLangCode),
    { enabled: !!id && modalMode === "edit" },
  );

  console.log('errors', errors)
  const showEmployes = showEmploy?.data.vendor || {};

  const rolesQuery = useQuery("getRoles", () => getRoles("vendor"));

  const roles = rolesQuery.data?.data?.roles || [];
  useEffect(() => {
    if (modalMode === "edit" && showEmploy) {
      setFormData((prev) => ({
        ...prev,
        first_name: showEmployes?.first_name,
        last_name: showEmployes?.last_name,
        role: showEmployes?.role,
        email: showEmployes?.email,
        phone: showEmployes?.phone,
        phone_code: showEmployes?.phone_code,
        store_id: showEmployes?.store?.id,
        store_name: showEmployes?.store?.name,
        is_active: showEmployes?.is_active,
        is_owner: showEmployes?.is_owner ? 1 : 0,
      }));
    }
  }, [showEmploy]);

  console.log(
    "store_name",formData.store_name
  );
 

  const validate = () => {
    let newErrors = {};

    if (!formData.first_name) newErrors.first_name = ["الاسم الأول مطلوب"];
    if (!formData.last_name) newErrors.last_name = ["الاسم الأخير مطلوب"];
    if (!formData.store_id && is_store) newErrors.store_id = ["رجاء اختيار متجر"];
    if (!formData.role) newErrors.role = ["رجاء اختيار الدور"];
// البريد الإلكتروني
  if (!formData.email) {
    newErrors.email = ["البريد الإلكتروني مطلوب"];
  } else if (!/\S+@\S+\.\S+/.test(formData.email)) {
    newErrors.email = ["حقل email يجب أن يكون بريدًا إلكترونيًا صالحًا"];
  }

      if (!formData.phone || !formData.phone_code) {
    newErrors.phone = ["رقم الهاتف مطلوب"];
  } else {
    const fullPhone = `${formData.phone_code}${formData.phone}`;
    if (!isPossiblePhoneNumber(fullPhone)) {
      newErrors.phone = ["رقم الهاتف غير مكتمل"];
    } else if (!isValidPhoneNumber(fullPhone)) {
      newErrors.phone = ["رقم الهاتف غير صالح"];
    }
  }
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };
  console.log('errors', formData.store_id, formData.store_name)

  const handlePhoneChange = ({ phone, phone_code }) => {
    setFormData((prev) => ({
      ...prev,
      phone,
      phone_code,
    }));
  };
  const mutation = useMutation({
    mutationKey: ["postData"],
    mutationFn: (data) => postVendors(data),
    onSuccess: (data) => {
      toast.success(data.message);
      if (onVendorCreated) {
        onVendorCreated(data.data.vendor);
      }
      onClose();
      refetch();
    },
    onError: (error) => {
      const responseData = error.response?.data;
      if (responseData?.data) {
        setErrors(responseData.data); // server validation errors
        toast.error(responseData?.message || "حدث خطأ ما");
      }
    },
  });
  const mutationUpdate = useMutation({
    mutationKey: ["updateVendors"],
    mutationFn: (data) => updateVendors(data, id),
    onSuccess: (data) => {
      toast.success(data.message);
      onClose();
      refetch();
    },
    onError: (error) => {
      const responseData = error.response?.data;
      if (responseData?.data) {
        setErrors(responseData.data); // server validation errors
      } else {
        toast.error(responseData?.message || "حدث خطأ ما");
      }
    },
  });

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? (checked ? 1 : 0) : value,
    }));
    setErrors({});
  };

  const setStoreId = (id,name) => {
    setFormData((prev) => ({
      ...prev,
      store_id: id,
      store_name:name
    }));
  };
  const handleLangCodeChange = (e) => {
    setSelectedLangCode(e.target.value);
  };

  const handleSubmit = () => {
    if (modalMode === "edit") {
      const updateFormData = {
        ...formData,
        _method: "PUT",
        lang: selectedLangCode,
      };
      mutationUpdate.mutate(updateFormData);
    } else {
      if (!validate()) return;
      mutation.mutate(formData);
    }
  };

  console.log("formData.phone_code", formData.phone_code);
  return (
    <Modal show={show} onHide={onClose} rounded size="md" centered>
      <Modal.Header closeButton>
        <Modal.Title>
          {" "}
          {modalMode === "edit" ? "تعديل تاجر /موظف" : "إضافة تاجر/ موظف "}{" "}
        </Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <Form className="row add">
          {modalMode === "edit" ? (
            <div className="col-12">
              <LangSelectModal
                handleChange={handleLangCodeChange}
                selectedLangCode={selectedLangCode}
              />
            </div>
          ) : null}

          {/* first name */}
          <div className="col-md-6">
            <Form.Group className="mb-3">
              <Form.Label>الاسم الأول</Form.Label>
              <SkeletonWrapper isLoading={isLoading}>
                <Form.Control
                  type="text"
                  name="first_name"
                  value={formData.first_name}
                  onChange={handleChange}
                  className={errors.first_name ? "is-invalid" : ""}
                />
              </SkeletonWrapper>

              {errors.first_name && (
                <div className="d-block invalid-feedback">{errors.first_name[0]}</div>
              )}
            </Form.Group>
          </div>

          {/* last name */}
          <div className="col-md-6">
            <Form.Group className="mb-3">
              <Form.Label>الاسم الأخير</Form.Label>
              <SkeletonWrapper isLoading={isLoading}>
                <Form.Control
                  type="text"
                  name="last_name"
                  value={formData.last_name}
                  onChange={handleChange}
                  className={errors.last_name ? "is-invalid" : ""}
                />
              </SkeletonWrapper>
              {errors.last_name && (
                <div className="d-block invalid-feedback">{errors.last_name[0]}</div>
              )}
            </Form.Group>
          </div>

          {/* store */}
       {  is_store && <div className="col-md-6">
            <Form.Group className="mb-3">
              <Form.Label>المتجر</Form.Label>

              <EnhancedSearchStoreGroup
                setStoreId={setStoreId}
                value={(formData.store_name&& formData.store_id) ? { id: formData.store_id, name: formData.store_name } : null}
                showEmployes={showEmployes}
              />

              {errors.store_id && (
                <div className="d-block invalid-feedback">{errors.store_id[0]}</div>
              )}
            </Form.Group>
          </div>
}
          {/* role */}
          <div className="col-md-6">
            <Form.Group className="mb-3">
              <Form.Label>الدور</Form.Label>
              <SkeletonWrapper isLoading={rolesQuery.isLoading}>
                <Form.Select
                  name="role"
                  value={formData.role}
                  onChange={handleChange}
                  className={errors.role ? "is-invalid" : ""}
                >
                  <option value="">اختار الدور</option>
                  {roles.map((role) => (
                    <option key={role.id} value={role.name}>
                      {role.name}
                    </option>  
                  ))}
                </Form.Select>
              </SkeletonWrapper>
              {errors.role && (
                <div className=" d-block invalid-feedback">{errors.role[0]}</div>
              )}
            </Form.Group>
          </div>

          {/* phone */}
          <Form.Group className="mb-3">
            <SkeletonWrapper isLoading={isLoading}>  
              <PhoneField
                onChange={handlePhoneChange}
                phone={formData.phone}
                phone_code={formData.phone_code}
                setErrors={setErrors}
              />
            </SkeletonWrapper>
            {errors.phone && (
              <div className="d-block invalid-feedback">{errors.phone[0]}</div>
            )}
          </Form.Group>

          {/* email */}
          <Form.Group className="mb-3">
            <Form.Label>الإيميل</Form.Label>
            <SkeletonWrapper isLoading={isLoading}>
              <Form.Control
                type="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                className={errors.email ? "is-invalid" : ""}
              />
            </SkeletonWrapper>
            {errors.email && (
              <div className="d-block invalid-feedback">{errors.email[0]}</div>
            )}
          </Form.Group>

       {is_store? <SkeletonWrapper isLoading={isLoading}>
            <label className="form-label" htmlFor="">
              {formData.is_owner === 1 ? `مالك` : `ليس مالك`}
            </label>
            <label class="switch">
              <input
                name="is_owner"
                type="checkbox"
                onChange={handleChange}
                checked={formData.is_owner === 1}
              />
              <span className="slider round"></span>
            </label>
          </SkeletonWrapper> :null}
        </Form>
      </Modal.Body>

      <Modal.Footer className="justify-content-start">
        <button
          className="btn btn-primary"
          onClick={handleSubmit}
          disabled={mutation.isLoading || mutationUpdate.isLoading}
        >
          {mutation.isLoading || mutationUpdate.isLoading ? (
            <Spinner size="sm" />
          ) : modalMode === "edit" ? (
            "تعديل موظف"
          ) : (
            "إضافة موظف"
          )}
        </button>

        <button
          className="btn btn-light"
          onClick={onClose}
          disabled={mutation.isLoading}
        >
          إلغاء
        </button>
      </Modal.Footer>
    </Modal>
  );
};

export default AddEmployeeModal;
